import styled from 'styled-components';
import { spacing } from '_utils/props';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { heading_xl, heading_l, heading_m, heading_s, heading_xs } from '_utils/styles/';
import ContentRichText from '_components/Corporate/ContentRichText';

export const Container = styled.div``;

export const Heading = styled(Text)`
  h2& {
    ${heading_xl}
  }

  h3& {
    ${heading_l}
  }

  h4& {
    ${heading_m}
  }

  h5& {
    ${heading_s}
  }

  h6& {
    ${heading_xs}
  }

  h2&,
  h3&,
  h4& {
    ${({ theme }) => spacing({ theme, pb: 3 })}
  }

  h5&,
  h6& {
    ${({ theme }) => spacing({ theme, pb: 2 })}
  }
`;

export const RichText = styled(ContentRichText)`
  ${({ theme }) =>
    spacing({
      theme,
      pb: 3
    })}

  > :last-child {
    margin-bottom: 0;
  }
`;
